import { removeClass } from "@/lib/dom/removeClass"
import { removeNode } from "@/lib/dom/removeNode"
import { apiHomePageHeader } from "@/api/ajaxHomePageHeader";

const GetCouponClipped = () => {
  const param = { getTrue: 'true' };
  fetch('../Ajax/Customer.aspx/GetCouponClipped', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json', // 指定发送的数据格式为 JSON
    },
    body: JSON.stringify(param)

  }).then(r => r.json()).then(res => {

    const jsonData = JSON.parse(res.d);
    if (jsonData.ReturnValue == 'Ok') {
      removeNode(".couponcode-block");
      document.querySelector('#text_couponcode')!.insertAdjacentHTML('afterend', jsonData.ReturnText);
    }
  })
}


export const AjaxCouponClippedHeader = () => {
  apiHomePageHeader().then(data => {
    const arrhead = data.split('^_|_^');

    removeNode("#menu-3");

    const headCouponClipped = document.getElementById('head-couponClipped');
    if (headCouponClipped) {
      headCouponClipped.innerHTML = arrhead[5];
      headCouponClipped.insertAdjacentHTML('afterend', arrhead[6]); // arrhead[6] 是 HTML 片段
    }

  });

}
const DeleteCouponClipped = (sysNo: number, elem: HTMLElement) => {
  const url = '/Ajax/Customer.aspx/DeleteCouponClipped';
  const param = {
    sysNo: sysNo
  }

  fetch(url, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json', // 指定发送的数据格式为 JSON
    },
    body: JSON.stringify(param)
  }).then(r => r.json()).then(res => {
    const jsonData = JSON.parse(res.d);
    if (jsonData.ReturnValue == 'Ok') {
      AjaxCouponClippedHeader();

      const elem = document.getElementById(jsonData.ReturnText) as HTMLInputElement
      if (elem) {
        elem.value = 'Clip Coupon';
        removeClass(elem, 'clipped');
      }
      if ($('.couponcode-block').length > 0) {
        GetCouponClipped();
      }

      // const couponClipboard = document.querySelector("#header-couponClipboard");
      // if (couponClipboard) {
      //   // off(couponClipboard, 'mouseover')
      //   on(couponClipboard, 'mouseover', (e: MouseEvent) => {
      //     const target = e.target! as HTMLElement;
      //     if (checkHover(e, target)) {
      //     }

      //   })
      // }
    }
    else {
      alert(jsonData.ReturnText);
    }
  }).finally(() => {
    // hideLoading(document.querySelector(".head-coupon__list")! as HTMLElement);
  });
}


export const removeCouponCode = (sysNo: number, elem: HTMLElement) => {
  // import("@/lib/popConfirm").then(({ popConfirm }) => {

  //   popConfirm(elem, {
  //     position: 'left',
  //     content: 'Are you sure you want to remove this coupon?',
  //     contanter: document.querySelector(".head-coupon__list"),
  //     confirm: () => {
  //       DeleteCouponClipped(sysNo, elem);
  //     }

  //   })

  // })
  if (confirm('Are you sure you want to remove this coupon?')) {
    DeleteCouponClipped(sysNo, elem);
  }

  //RemoveCouponClipped 
}
